import React, { Component, useState, Fragment } from "react";
import settings from '../settings.json';
import './../App.css';
import InputGroup from 'react-bootstrap/InputGroup';
import { Modal, Button, Form } from "react-bootstrap";


export default class hello extends Component{
  componentDidMount () {

  }


  render(){
    return (
      <div className="Top">
        <h1>Hello, Replace!</h1>
      </div>
    );
  }
}

